export default () => Component(function ($context) {
	return $context.select('.yt-video');
}, function ($ytVideoBlock, self) {
	$.extend(self, {
		setupVideo: function() {
			var link = $ytVideoBlock.find('.yt-video__link');
			var media = $ytVideoBlock.find('.yt-video__media');
			var button = $ytVideoBlock.find('.yt-video__button');
			var id = self.parseMediaURL(media);

			$ytVideoBlock.on('click', function(e){
				e.stopPropagation();
				var iframe = self.createIframe(id);

				link.remove();
				button.remove();
				$ytVideoBlock.append(iframe);
				$ytVideoBlock.off('click');
			});

			link.removeAttr('href');
			$ytVideoBlock.addClass('yt-video_enabled');
		},
		parseMediaURL: function(media) {
			var url = $(media).attr('src');
			var regexp;
			if (url.indexOf('maxresdefault') >= 0) {
				regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)\/maxresdefault\.jpg/i;
			} else {
				regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)\/hqdefault\.jpg/i;
			}

			var match = url.match(regexp);

			return match[1];
		},
		createIframe: function(id) {
			var iframe = $('<iframe></iframe>');

			iframe.attr('allowfullscreen', true);
			iframe.attr('allow', 'autoplay');
			iframe.attr('loading', 'lazy');
			iframe.attr('src', self.generateURL(id));
			iframe.addClass('yt-video__media');

			return iframe;
		},
		generateURL: function(id) {
			var query = '?rel=0&showinfo=0&autoplay=1';

			return 'https://www.youtube.com/embed/' + id + query;
		}
	});

	self.setupVideo();
});
